export default class Tab {
    /**
     * @constructor
     * @param {String} header
     * @param {String} value
     */
    constructor ({header, value}) {
        Object.assign(this, { header, value });
    }
}
